import ThreeDRotation from '@mui/icons-material/ThreeDRotation';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ThreeDRotationIcon(props: FixMe) {
  return <ThreeDRotation {...props} />;
}

export default ThreeDRotationIcon;
